import 'css-chunksrc/client/pages/projectPage/resourcesPage/resourcesList/styles.scss';export default {
  "resourcesList": "_resourcesList_bmssq_1",
  "heading": "_heading_bmssq_12",
  "label": "_label_bmssq_21",
  "cogWheel": "_cogWheel_bmssq_30",
  "cogIcon": "_cogIcon_bmssq_39",
  "main": "_main_bmssq_46",
  "listScroll": "_listScroll_bmssq_55",
  "list": "_list_bmssq_55",
  "item": "_item_bmssq_64",
  "contextualMenu": "_contextualMenu_bmssq_68",
  "button": "_button_bmssq_72",
  "toggleIcon": "_toggleIcon_bmssq_89",
  "menu": "_menu_bmssq_95",
  "action": "_action_bmssq_104",
  "buttonText": "_buttonText_bmssq_112"
};